"use client";

import React from "react";
import { ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3 w-full">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-[12px] font-default text-muted-foreground hover:text-primary transition-colors duration-200">
            {item.label}
          </Link>
        </div>)}
    </nav>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <section data-section-id="259881" id="footer" className="bg-background text-foreground pt-24 pb-8 px-6 md:px-12 border-t border-primary/30">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-y-16 gap-x-6 md:gap-x-12">
          
          {}
          <div className="col-span-12 md:col-span-5 lg:col-span-4 flex flex-col items-start">
            <Link to="/" className="mb-8 inline-block">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <address className="not-italic text-[12px] font-default text-muted-foreground flex flex-col gap-2">
              <span>Independent Alpha for the Modern Investor</span>
              <Link to="mailto:contact@yedeyinvestments.com" className="hover:text-primary transition-colors mt-2">
                contact@yedeyinvestments.com
              </Link>
              
            </address>
          </div>

          {}
          <div className="col-span-12 md:col-span-3 lg:col-span-4 flex flex-col items-start md:items-center">
            <div className="flex flex-col items-start w-full md:w-auto">
              <h4 className="text-[10px] font-bold font-default mb-6 uppercase tracking-[0.2em] text-muted-foreground">
                Sitemap
              </h4>
              <MenuProvider menu_id="footer_menu">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>
          </div>

          {}
          <div className="col-span-12 md:col-span-4 lg:col-span-4 flex flex-col items-start md:items-end">
            <h4 className="text-[10px] font-bold font-default mb-6 uppercase tracking-[0.2em] text-muted-foreground">
              Intelligence
            </h4>
            <div className="flex flex-col gap-4 items-start md:items-end">
              <Link to="https://x.com/yedeyEsp" newTab className="relative inline-block text-[12px] font-medium text-muted-foreground hover:text-primary transition-colors group py-1">
                <span className="relative z-10">X / Twitter</span>
                <span className="absolute left-0 top-1/2 h-[1px] w-0 bg-primary transition-all duration-300 ease-out group-hover:w-full -translate-y-1/2 z-20 opacity-90"></span>
              </Link>
              
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 pt-8 border-t border-border/50 flex flex-col-reverse md:flex-row justify-between items-center gap-6">
          <p className="text-[10px] font-mono text-muted-foreground uppercase tracking-widest text-center md:text-left">
            © {new Date().getFullYear()} YEDEY INVESTMENTS. High-Conviction Analysis.
          </p>

          <Button variant="outline" size="icon" className="rounded-md border-primary/20 bg-transparent hover:bg-primary/10 hover:text-primary transition-colors shadow-md" onClick={scrollToTop} aria-label="Scroll to top">
            <ArrowUp className="size-4" />
          </Button>
        </div>
      </div>
    </section>;
}